import React from "react";

import {
  ControlReviewService,
  ControlReviewSwagger,
  SwaggerControlReviewDao,
} from "@egis-smartcity/parking";
import ControlReviewContext, {
  ControlReviewState,
} from "./ControlReviewContext";
import useAuth from "../../hooks/useAuth";
import useCityConfig from "../../hooks/useCityConfig";

export type ControlReviewProviderProps = React.PropsWithChildren<{}>;

function ControlReviewProvider(props: ControlReviewProviderProps) {
  const { children } = props;
  const { cityConfig } = useCityConfig();
  const { token } = useAuth();

  const controlReviewService: ControlReviewService | undefined =
    React.useMemo(() => {
      if (!cityConfig || !token) return;

      const controlReviewSwaggerClient = new ControlReviewSwagger.ControlApi(
        new ControlReviewSwagger.Configuration({
          basePath: cityConfig.review.controlReview.url,
          apiKey: `Bearer ${token}`,
        })
      );
      const statisticsSwaggerClient = new ControlReviewSwagger.StatisticsApi(
        new ControlReviewSwagger.Configuration({
          basePath: cityConfig.review.controlReview.url,
          apiKey: `Bearer ${token}`,
        })
      );
      const swaggerControlReviewDao = new SwaggerControlReviewDao(
        controlReviewSwaggerClient,
        statisticsSwaggerClient
      );

      return new ControlReviewService(swaggerControlReviewDao);
    }, [cityConfig, token]);

  const controlReviewState: ControlReviewState = React.useMemo(() => {
    return { controlReviewService };
  }, [controlReviewService]);

  return (
    <ControlReviewContext.Provider value={controlReviewState}>
      {children}
    </ControlReviewContext.Provider>
  );
}

export default ControlReviewProvider;
